export default __webpack_public_path__ + "static/730-df56d1b03518b04609be239297672b92.gif";